import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["width", "height"];
const _hoisted_2 = ["stroke"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: $props.width,
    height: $props.height,
    viewBox: "0 0 17 17",
    fill: "none"
  }, [_createElementVNode("path", {
    d: "M6.8335 10.4987V6.4987M10.1668 10.4987V6.4987M15.1668 8.4987C15.1668 12.1806 12.1821 15.1654 8.50016 15.1654C4.81826 15.1654 1.8335 12.1806 1.8335 8.4987C1.8335 4.8168 4.81826 1.83203 8.50016 1.83203C12.1821 1.83203 15.1668 4.8168 15.1668 8.4987Z",
    stroke: $props.color,
    "stroke-width": "1.33333",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null, 8, _hoisted_2)], 8, _hoisted_1);
}